<template>
    <div class="editor"
         :class="{'disabled':data.disabled}">
        <textarea
            :id="inputFieldId"
            :name="name"
        />
    </div>
</template>

<script>
import {InputMixin} from './mixin/InputMixin.js';

export default {
    name: "TextEditor",
    mixins: [InputMixin],
    mounted() {
        // Listen for Summernote ready event
        $(document).on('summernote:ready', () => {
            this.initSummernoteComponent();
        });
        
        // If Summernote is already available, initialize immediately
        if (typeof $ !== 'undefined' && $.fn.summernote) {
            this.initSummernoteComponent();
        }
    },
    watch: {
        editorValue: function (value) {
            if (!value) this.setInitValue(value);
        }
    },
    computed: {
        editorValue() {
            return this.value;
        }
    },
    methods: {
        initSummernoteComponent() {
            // Ensure the element exists
            if (!$("#" + this.inputFieldId).length) {
                console.warn('TextEditor element not found:', this.inputFieldId);
                return;
            }
            
            // Initialize Summernote
            this.initComponent(this.value);
            
            // Bind change event
            $("#" + this.inputFieldId).off("summernote.change").on("summernote.change", () => {
                this.input()
            });
        },
        
        initComponent(initialValue) {
            let config = {
                placeholder: this.data.placeholder,
                dialogsInBody: true,
                height: this.data.height,
            };
            if (Object.keys(this.data.textEditorHints).length) {
                config.hint = this.data.textEditorHints
            }
            if (this.data.minimal === true) {
                config.toolbar = [
                    ['style', ['bold', 'italic', 'underline']],
                    ['fontsize', ['fontsize', 'height', 'color']],
                    ['para', ['ul', 'ol']],
                    ['insert', ['picture', 'link', 'video']]
                ]
            }
            $("#" + this.inputFieldId).summernote(config);
            this.setInitValue(initialValue);
        },

        setInitValue(initialValue) {
            $("#" + this.inputFieldId).summernote('code', initialValue);
        },
        input() {
            this.fieldValue = $('#' + this.inputFieldId).summernote('code');
            this.$emit('input', this.fieldValue);
        }
    }
}
</script>
